//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import qs from "qs";
let accesstoken = null;
export default {
  name: "login",
  data() {
    return {
      canLogin: false,
      form: {
        phone: "",
        password: "",
      },
    };
  },
  mounted() {
    // if(this.$route.query.from=='entercode'){
    //   this.$vux.alert.show({
    //     title:'提示',
    //     content:'请登录后重新输入兑换码或扫描二维码'
    //   })
    // }
  },
  created() {
    let query = qs.stringify(this.$route.query, { filter: ["from"] });
    var encodeurl = encodeURIComponent(
      `${location.protocol}//${location.host}${this.$route.path}?${query}`
    );
    let appid = "wxab0282ef768c18ac";
    if (process.env.NODE_ENV == "test") {
      appid = "wxab0282ef768c18ac";
    }
    if (
      this.$route.query.code &&
      this.$route.query.state == "gaishi_get_code"
    ) {
      // this.changeCode(this.$route.query.code).then(res=>{
      //   // this.$router.replace({name:'login',query:{test:true}});
      //   accesstoken=res;
      //   console.log('临时token:',res);
      // }).catch(error=>{
      //   if(error.data.message=='openid 为空'){
      //       location.assign(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`);
      //   }
      // });
    } else {
      // if(this.getParam('code')&&this.getParam('state')=='gaishi_get_code'){
      //   let url=location.protocol+'//'+location.host+'/#/?code='+this.getParam('code')+'&state='+this.getParam('state');
      //   location.assign(url);
      // }else{
      if (window.debug) {
        return;
      }
      if (process.env.NODE_ENV === "development") {
        location.assign(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`
        );
      } else {
        location.assign(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeurl}&response_type=code&scope=snsapi_userinfo&state=gaishi_get_code#wechat_redirect`
        );
        // location.href=
      }
      // }
    }
  },
  methods: {
    ...mapActions(["changeCode", "changeUserInfo"]),
    login() {
      let data = this.form;
      data.user_key = accesstoken;
      this.axios.post("/xcx/Login/login", data).then((res) => {
        // localStorage.setItem('token',res.data.data.access_token);
        this.$cookies.set("token", res.data.data.access_token);
          this.changeUserInfo(res.data.data).then((_) => {
            // this.$router.push({name:'tutorial'})
            if (this.$route.query.from == "qrcode") {
              this.axios
                .post("/xcx/Order/testRecommend", { test_result: 1, type: 1 })
                .then((res) => {
                  this.$router.replace({
                    name: "tutorial",
                    params: { showalert: true },
                  });
                });
            } else {
              this.$router.replace({ name: "tutorial" });
            }
          });
      });
    },
  },
  watch: {
    form: {
      handler: function (n) {
        if (n.phone != "" && n.password != "") {
          this.canLogin = true;
        } else {
          this.canLogin = false;
        }
      },
      deep: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/login.vue